import { Form, Popover, Spin, Typography } from 'antd';
import { useEffect, useState } from 'react';
import ContainerLookupDetails from './ContainerLookupDetails';
import { FormContainer, FormItemInputStyled, FormItemStyled, PageTitle } from '../Styled/GlobalStyles';
import { FormFooter } from '../Shared/FormFooter';
import { CommonForm } from '../Shared/CommonForm';
import { ContactInfo } from './components/ContactInfo';
import { logEvent } from '../../util/Analytics';
import { showNotification } from '../../util/Notifications';
import { ErrorResponseDto } from '../../models/ErrorResponseDto';
import ContainerLookupDetailsDto from '../../models/ContainerLookupDetailsDto';
import { logUserTrack } from '../Shared/userTrack';

const { Text } = Typography;

const ContainerLookup = () => {
  const [form] = Form.useForm();
  const [containerDetailsList, setContainerDetailsList] = useState<ContainerLookupDetailsDto[]>([]);
  const [containerDetailsError, setContainerDetailsError] = useState<ErrorResponseDto | null>(null);
  const [isContainerDetailsLoading, setIsContainerDetailsLoading] = useState<boolean>(false);
  const [isFormDisabled, setIsFormDisabled] = useState<boolean>(true);

  const containerValue = Form.useWatch('Container', form);
  const billOfLadingValue = Form.useWatch('BOL', form);
  const [isContainerInputValid, setIsContainerInputValid] = useState<boolean>(true);

  const resetContainerDetailsForm = () => {
    setContainerDetailsError(null);
    setContainerDetailsList([]);
    form.resetFields();
  };

  const userClickedClearForm = () => {
    logEvent('container_lookup_clear');
    resetContainerDetailsForm();
  };

  const onFormSubmit = (values: any) => {
    logEvent('container_lookup_submit');

    try {
      logUserTrack('click', 'submit_container_lookup_form', values);
    } catch (error) {
      console.log(error);
    }

    if (!values.Container && !values.BOL) {
      showNotification({
        type: 'error',
        title: 'Error',
        message: 'Please enter a container number or bill of lading',
      });
      return;
    }

    setIsContainerDetailsLoading(true);
    setIsFormDisabled(true);

    fetch(`/api/containerDetails?containerNumber=${values.Container || ''}&billOfLading=${values.BOL || ''}`, {
      method: 'GET',
    })
      .then((response) => response.json())
      .then((data) => {
        if (!data.status) {
          setContainerDetailsList(data);
        } else {
          setContainerDetailsError(data);
          showNotification({
            type: 'error',
            title: 'Error',
            message: data.message,
          });
        }
      })
      .finally(() => {
        setIsContainerDetailsLoading(false);
        setIsFormDisabled(false);
      });
  };

  useEffect(() => {
    document.title = 'Container Lookup';
    // logPageView('Container Lookup');
  }, []);

  useEffect(() => {
    const containerRegex = /^(\*)?[A-Za-z]{4}\s?\d{6}-?\d$/;
    let isContainerInputValid = containerRegex.test(containerValue);
    if (!containerValue) {
      setIsContainerInputValid(true);
      isContainerInputValid = true;
    } else {
      setIsContainerInputValid(isContainerInputValid);
    }

    // Either a valid container number alone, or combination of valid container number and BOL
    setIsFormDisabled((!containerValue && !billOfLadingValue) || !isContainerInputValid);
  }, [containerValue, billOfLadingValue]);

  return (
    <>
      <PageTitle>CES Container Lookup</PageTitle>
      {!containerDetailsList.length && !containerDetailsError && (
        <CommonForm form={form} onFinish={onFormSubmit}>
          <Spin spinning={isContainerDetailsLoading} size='large'>
            <FormContainer>
              <FormItemStyled name='Container' label='Container'>
                <FormItemInputStyled
                  placeholder='Enter container'
                  size='large'
                  status={isContainerInputValid ? '' : 'error'}
                  allowClear={true}
                />
              </FormItemStyled>
              {!isContainerInputValid && <Text type='danger'>Invalid Container Number</Text>}

              <FormItemStyled name='BOL' label='BOL'>
                <FormItemInputStyled placeholder='Enter BOL' size='large' allowClear={true} />
              </FormItemStyled>

              <Popover content={<ContactInfo />} placement='right'>
                <Text>CES - Contact Info</Text>
              </Popover>
            </FormContainer>
          </Spin>

          <FormFooter searchDisabled={isFormDisabled} resetForm={userClickedClearForm} />
        </CommonForm>
      )}
      <ContainerLookupDetails
        containerDetailsList={containerDetailsList}
        resetContainerDetailsForm={resetContainerDetailsForm}
        containerDetailsError={containerDetailsError}
      />
    </>
  );
};

export default ContainerLookup;
